export type CommentEditMetaProps = {
  createdAt: string | null | undefined;
  editedAt?: string | null;
  editCount?: number;
  /** Last save was by admin/superuser editing someone else's comment */
  lastEditedByAdmin?: boolean;
  className?: string;
};

/** Posted time plus optional edit count and last-edited time */
export function CommentEditMeta({
  createdAt,
  editedAt,
  editCount,
  lastEditedByAdmin,
  className = 'text-xs text-stone-400 mt-2',
}: CommentEditMetaProps) {
  const posted = createdAt ? new Date(createdAt).toLocaleString() : '';
  const n = editCount ?? 0;
  const showEdits = n > 0 && editedAt;
  return (
    <p className={className}>
      Posted {posted}
      {showEdits ? (
        <>
          {' '}
          · Edited {n} {n === 1 ? 'time' : 'times'}
          {lastEditedByAdmin ? ' by admin' : ''}, last {new Date(editedAt).toLocaleString()}
        </>
      ) : null}
    </p>
  );
}
